var map = {
	"./testimonial_0.png": "a552",
	"./testimonial_1.png": "a5ca",
	"./testimonial_2.png": "b805",
	"./testimonial_3.png": "3420",
	"./testimonial_4.png": "bf02",
	"./testimonial_5.png": "fa38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01f2";